import classNames from 'classnames';
import * as React from 'react';

import { DiscountType } from '../../../../../Blocks/DiscountType.csharp';
import { AppliedFreeItemPromotionViewModel } from '../../../../../Catalog/Product/Promotion/AppliedFreeItemPromotionViewModel.csharp';
import { PriceDisplay } from '../../../../../ReactComponents/PriceDisplay';
import { CartItemViewModel } from '../../ViewModels/CartItemViewModel.csharp';

interface CartItemPriceProps {
    item: CartItemViewModel;
    showQuantity?: boolean;
    isQuantityLoaderActive: boolean;
}

export const CartItemPrice = (props: CartItemPriceProps) => {
    const cheapestForFreeDiscounts = props.item.appliedDiscounts.filter((p) => p.discountType == DiscountType.CheapestForFree);
    const appliedCheapestForFreePromotion = cheapestForFreeDiscounts.length == 1 && (cheapestForFreeDiscounts[0] as AppliedFreeItemPromotionViewModel);

    const currentQuantity = props.item.quantityOrdered - props.item.quantityCancelled;

    const freeQuantity = appliedCheapestForFreePromotion ? appliedCheapestForFreePromotion.numberOfFreeItems : 0;
    const chargedQuantity = freeQuantity ? currentQuantity - freeQuantity : currentQuantity;
    const allItemsFree = currentQuantity <= freeQuantity && props.item.discountedPrice === 0;

    let discountedPricePerItem = allItemsFree
        ? 0
        : freeQuantity
        ? props.item.discountedPrice / (currentQuantity - freeQuantity)
        : props.item.discountedPrice / currentQuantity;

    const isDiscountedPriceCorrect = discountedPricePerItem <= props.item.placedPrice || allItemsFree;
    discountedPricePerItem = isDiscountedPriceCorrect ? discountedPricePerItem : props.item.discountedPrice / currentQuantity;
    const shouldRenderQuantity =
        props.showQuantity && ((!!discountedPricePerItem && !!currentQuantity) || (props.item.isReplacement && currentQuantity > 1) || allItemsFree);
    const shouldRenderDiscount = !props.item.isReplacement && props.item.hasDiscount;
    const renderChargedQuantity = () => {
        return (
            shouldRenderQuantity &&
            (chargedQuantity > 0 || !allItemsFree) && (
                <span className="CartItem__OrderedQuantity">
                    {isDiscountedPriceCorrect ? chargedQuantity : currentQuantity} x {<PriceDisplay price={discountedPricePerItem} />}
                </span>
            )
        );
    };

    const renderFreeQuantity = () => {
        return (
            shouldRenderQuantity &&
            (freeQuantity > 0 || allItemsFree) &&
            isDiscountedPriceCorrect && (
                <span className="CartItem__OrderedQuantity">
                    {allItemsFree ? currentQuantity : freeQuantity} x <PriceDisplay price={0} />
                </span>
            )
        );
    };

    const renderPrice = () => {
        return (
            <div className={classNames('CartItem__PriceTotal', props.item.hasDiscount ? 'CartItem__PriceTotal--Discounted' : '')}>
                <PriceDisplay price={props.item.discountedPrice} />
            </div>
        );
    };

    const renderDiscount = () => {
        let discountLength = 0;
        const discountInfo = props.item.appliedDiscounts.map((d, i) => {
            discountLength += d.shortInfo.length;
            return (
                <span key={i}>
                    {d.shortInfo}
                    {i < props.item.appliedDiscounts.length - 1 && ', '}
                </span>
            );
        });

        return (
            <div className={classNames('CartItem__Discount', discountLength > 10 ? 'CartItem__Discount--Column' : '')}>
                <span className="CartItem__OriginalPrice">
                    <PriceDisplay price={props.item.placedPrice * props.item.quantityOrdered} />
                </span>
                <div className={classNames('CartItem__DiscountInfo', discountLength > 10 ? 'CartItem__DiscountInfo--Column' : '')}>{discountInfo}</div>
            </div>
        );
    };

    return (
        <div className={classNames('CartItem__Pricing', props.showQuantity && 'CartItem__Pricing--WithQuantity')}>
            <div className="CartItem_PriceWrapper">
                {renderChargedQuantity()}
                {renderFreeQuantity()}
                {shouldRenderDiscount && renderDiscount()}
                {renderPrice()}
            </div>
        </div>
    );
};
